import { render, staticRenderFns } from "./SearchedTerms.vue?vue&type=template&id=6e2f82b3&scoped=true&"
import script from "./SearchedTerms.vue?vue&type=script&lang=js&"
export * from "./SearchedTerms.vue?vue&type=script&lang=js&"
import style0 from "./SearchedTerms.vue?vue&type=style&index=0&id=6e2f82b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f82b3",
  null
  
)

export default component.exports